import { createContext, useContext } from "react";


export interface StoreContextType {
  title: string
  setTitle: (title: string) => void
  id: number
}

export const StoreContext = createContext<StoreContextType>({
  title: "Solace",
  id: 0,
  setTitle: (title: string) => {}

});

export const useStoreContext = () => useContext(StoreContext)